import type { SelectHTMLAttributes } from 'react'
import { Box } from '@chakra-ui/react'
import { useFormColors } from './FormThemeContext'

interface StyledSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children: React.ReactNode
}

export function StyledSelect({ children, style, ...props }: StyledSelectProps) {
  const c = useFormColors()

  const selectStyles: React.CSSProperties = {
    width: '100%',
    padding: '0.75rem 2.5rem 0.75rem 1rem',
    borderRadius: '0.25rem',
    border: 'none',
    fontSize: '0.875rem',
    background: c.bgInput,
    color: c.text,
    outline: 'none',
    appearance: 'none',
    WebkitAppearance: 'none',
    cursor: 'pointer',
    ...style,
  }

  return (
    <Box position="relative">
      <select style={selectStyles} {...props}>
        {children}
      </select>
      <Box
        position="absolute"
        right="0.75rem"
        top="50%"
        transform="translateY(-50%)"
        pointerEvents="none"
        color={c.textSecondary}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </Box>
    </Box>
  )
}
